function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Finish = /*#__PURE__*/ function() {
    "use strict";
    function Finish() {
        _class_call_check(this, Finish);
        _define_property(this, "gallery", finishData);
        _define_property(this, "$els", {
            tabs: document.querySelectorAll('[data-tabs-control]'),
            content: document.querySelectorAll('[data-tabs-content]'),
            gallery: document.querySelectorAll('[data-tabs-gallery]'),
            video: document.querySelectorAll('[data-tab-gallery-video]')
        });
    }
    _create_class(Finish, [
        {
            key: "handleSliderUpdate",
            value: function handleSliderUpdate(type) {
                var _this_gallery_find;
                var slides = (_this_gallery_find = this.gallery.find(function(item) {
                    return item.type === type;
                })) === null || _this_gallery_find === void 0 ? void 0 : _this_gallery_find.gallery;
                if (slides.length) {
                    window.sliderFinish.removeAllSlides();
                    window.sliderFinish.appendSlide(slides.map(function(item) {
                        return '\n						<div class="swiper-slide">\n							<img src="'.concat(item, '" alt="" loading="lazy">\n						</div>\n					');
                    }));
                    window.sliderFinish.slideTo(0, 0);
                }
            }
        },
        {
            key: "handleVideoUpdate",
            value: function handleVideoUpdate(type) {
                this.$els.video.forEach(function($item) {
                    $item.classList.toggle('finish-tabs__video_show', $item.dataset.tabGalleryVideo === type);
                });
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var _this_$els_tabs, _this_$els_gallery, _document_querySelectorAll;
                this.handleSliderUpdate(document.querySelector('[data-tabs-gallery].finish-tabs__item_active').dataset.tabsGallery);
                (_this_$els_tabs = this.$els.tabs) === null || _this_$els_tabs === void 0 ? void 0 : _this_$els_tabs.forEach(function($tab, index) {
                    $tab.addEventListener('click', function() {
                        var _document_querySelectorAll;
                        (_document_querySelectorAll = document.querySelectorAll('.finish-tabs__item_active')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($active) {
                            $active.classList.remove('finish-tabs__item_active');
                        });
                        $tab.classList.add('finish-tabs__item_active');
                        _this.$els.content[index].classList.add('finish-tabs__item_active');
                    });
                });
                (_this_$els_gallery = this.$els.gallery) === null || _this_$els_gallery === void 0 ? void 0 : _this_$els_gallery.forEach(function($gallery, index) {
                    $gallery.addEventListener('click', function() {
                        var type = $gallery.dataset.tabsGallery;
                        var $radio = _this.$els.content[index].querySelector('input[value="'.concat(type, '"]'));
                        if ($radio) {
                            var _this_$els_content_index_querySelectorAll;
                            (_this_$els_content_index_querySelectorAll = _this.$els.content[index].querySelectorAll('input[type="radio"]')) === null || _this_$els_content_index_querySelectorAll === void 0 ? void 0 : _this_$els_content_index_querySelectorAll.forEach(function($itemRadio) {
                                $itemRadio.checked = false;
                            });
                            $radio.checked = true;
                        }
                        _this.handleSliderUpdate(type);
                        _this.handleVideoUpdate(type);
                    });
                });
                (_document_querySelectorAll = document.querySelectorAll('[name="style-radio"]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($radio) {
                    $radio.addEventListener('change', function() {
                        _this.handleSliderUpdate($radio.value);
                        _this.handleVideoUpdate($radio.value);
                    });
                });
                document.addEventListener('click', function(event) {
                    var $el = event.target;
                    if ($el.dataset.finishAnchor !== undefined) {
                        var _Array_from_find;
                        event.preventDefault();
                        var key = $el.getAttribute('href').substring(1);
                        (_Array_from_find = Array.from(_this.$els.tabs).find(function(item) {
                            return item.dataset.tabsGallery === key;
                        })) === null || _Array_from_find === void 0 ? void 0 : _Array_from_find.dispatchEvent(new CustomEvent('click'));
                        window.lenis.scrollTo('#finishing', {
                            duration: 3,
                            lock: true
                        });
                    }
                });
            }
        }
    ]);
    return Finish;
}();
export default Finish;
